import React from "react"
import { Dialog } from 'primereact/dialog';
import { DeleteHeader } from "./deletePopUp.style";
import { Button } from "primereact/button";
import PropTypes from 'prop-types';

function DeletePopUp({ deleteApproved,header, onHide, message, ...rest }) {
    return <Dialog headerStyle={{display:"none"}} contentStyle={{padding:"20px"}} style={{ overflow:"hidden",width: "360px", height: "200px" }} visible={true} closable={false} {...rest}>
        <div style={{textAlign: "center" }}>
            <i style={{ color: "#FF1414" }} className="pi pi-info-circle" />
            <DeleteHeader>{header}</DeleteHeader>
            <div style={{ padding: "10px" }}>{message}</div>
            <Button outlined onClick={onHide} style={{width:"100px",marginRight:"10px",marginTop:"10px",color:"#606060",border:"1px solid #606060"}} label="Cancel" />
            <Button onClick={()=>{
                deleteApproved()
                onHide()
            }} style={{ width:"100px",background: "#ED4949", color: "#ffffff",borderColor:"#ED4949" }} label="Delete" />
        </div>


    </Dialog>
}
DeletePopUp.propTypes = {
  deleteApproved: PropTypes.func.isRequired, // Add this line
  header:PropTypes.string,
  onHide:PropTypes.func,
  message:PropTypes.string
};
export default DeletePopUp